import React from 'react'
import {SavStatutCode} from '../../../../components/sav/Models'
import {SAV_STATUTS, SAV_STATUTS_FINAUX} from '../../../../components/sav/libelles'

type Props = {
  statut: SavStatutCode
  // Échange : l'étape Commande s'insère entre À solder et Clos
  echange?: boolean
}

// Stepper des statuts (maquette 0.6)
const SavStepper = ({statut, echange = false}: Props) => {
  const etapes: Array<{code: string; libelle: string}> = [
    'OUVERT',
    'RETOUR_ATTENDU',
    'RECU',
    'EN_CONTROLE',
    'A_SOLDER',
    ...(echange || statut === 'COMMANDE' ? ['COMMANDE'] : []),
  ].map((code) => ({code, libelle: SAV_STATUTS[code as SavStatutCode].libelle}))
  const final = SAV_STATUTS_FINAUX.includes(statut)
  etapes.push({code: 'CLOS', libelle: final ? SAV_STATUTS[statut].libelle : 'Clos'})
  const courante = etapes.findIndex((e) => e.code === (final ? 'CLOS' : statut))

  return (
    <div className='d-flex align-items-start'>
      {etapes.map((etape, i) => {
        const passee = i < courante
        const enCours = i === courante
        return (
          <React.Fragment key={etape.code}>
            {i > 0 && (
              <div
                className='flex-grow-1 mt-2'
                style={{
                  height: 2,
                  minWidth: 24,
                  backgroundColor: i <= courante ? '#1B84FF' : '#DBDFE9',
                }}
              />
            )}
            <div className='d-flex flex-column align-items-center px-1' style={{minWidth: 70}}>
              <span
                className='rounded-circle'
                style={{
                  width: 14,
                  height: 14,
                  backgroundColor: passee ? '#1B84FF' : '#FFFFFF',
                  border: `${enCours ? 4 : 2}px solid ${passee || enCours ? '#1B84FF' : '#DBDFE9'}`,
                }}
              />
              <span
                className={`fs-8 mt-1 text-center ${
                  enCours ? 'fw-bolder text-gray-900' : passee ? 'text-gray-700' : 'text-gray-400'
                }`}
              >
                {etape.libelle}
              </span>
            </div>
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default SavStepper
